import { useCallback } from 'react';

import { type User } from '@air/api/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type WithOnboardingAnalyticsCategory } from './onboardingAnalytics';
import META from './useTrackCompletedOnboardingBasicInfo.meta';

export type CompletedOnboardingBasicInfo = WithOnboardingAnalyticsCategory<
  Pick<User, 'email' | 'firstName' | 'lastName'>
>;

export const useTrackCompletedOnboardingBasicInfo = () => {
  const { track } = useAnalyticsUtilities();

  const trackCompletedOnboardingBasicInfo = useCallback(
    (params: CompletedOnboardingBasicInfo) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCompletedOnboardingBasicInfo };
};
